export default "__VITE_ASSET__DyF3ZbM3__"